import { render, staticRenderFns } from "./downgrade-recorde.vue?vue&type=template&id=5a854bff&scoped=true&lang=pug"
import script from "./downgrade-recorde.vue?vue&type=script&lang=js"
export * from "./downgrade-recorde.vue?vue&type=script&lang=js"
import style0 from "./downgrade-recorde.vue?vue&type=style&index=0&id=5a854bff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a854bff",
  null
  
)

export default component.exports